<template>
  <div v-if="screenData" class="sub-view analysis-zone">
    <div :class="['sub-view-wrapper', activeAside && 'opened']">
      <div class="sub-view-gabarit">
        <div class="header-box">
          <h4>{{ $t('sections.environmental') }}</h4>
          <p v-if="!yearly && !weighted">{{ $t('sections.environmentalDescriptionJourney') }}</p>
          <p v-if="yearly && !weighted">{{ $t('sections.environmentalDescription') }}</p>
          <p v-if="yearly && weighted">{{ $t('sections.environmentalDescriptionWeighted') }}</p>
        </div>
        <Filters />
        <AnalysisSection>
          <template #header>
            <h5>{{ $t('report.environmentalImpact') }}</h5>
          </template>
          <template #action>
            <div class="action-container">
              <div class="action-button" :class="{ active: !yearly && !weighted }" @click="switchMode(false, false)">{{ $t('sections.byJourney') }}</div>
              <div class="action-button" :class="{ active: yearly && !weighted }" @click="switchMode(true, false)">{{ $t('sections.byYear') }}</div>
              <div class="action-button long" :class="{ active: yearly && weighted }" @click="switchMode(true, true)">{{ $t('sections.byYearWeighted') }}</div>
            </div>
          </template>
          <template #body>
            <Impact :data="screenData" :yearly="yearly" :weighted="weighted" />
          </template>
        </AnalysisSection>
      </div>
      <FooterSection v-if="isDesktop" class="footer-section" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Analysis from './AnalysisMixin';
import Impact from '@/components/Analysis/Environmental/Impact';
import FooterSection from '@/components/Footer';

export default {
  components: {
    Impact,
    FooterSection,
  },

  mixins: [Analysis],

  data() {
    return {
      yearly: true,
      weighted: false,
    };
  },

  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop',
    }),
  },

  methods: {
    switchMode(yearly, weighted) {
      this.yearly = yearly;
      this.weighted = weighted;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.action-button {
  margin-left: auto;
  margin-right: 12px;
  padding: 8px 12px;
  border: solid 1px colors.$nude-concrete-color;
  border-radius: 8px;
  color: colors.$dark-grey-color;
  transition: 200ms ease-in-out;
  cursor: pointer;

  &:hover {
    background: colors.$clear-border-color;
  }

  &:active {
    opacity: 0.8;
  }
}

.action-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 192px;
  font-size: 12px;
  margin: 0 16px 0 auto;

  .action-button {
    border-radius: 0;
    border-color: colors.$navy-color;
    margin: 0;
    min-width: 78px;
    text-align: center;

    &:first-child {
      border-radius: 8px 0 0 8px;
      border-right: 0;
    }
    &:last-child {
      border-radius: 0 8px 8px 0;
      border-left: 0;
    }
    &:hover {
      background: rgba(colors.$navy-color, 0.2);
    }

    &.long {
      min-width: 134px;
    }

    &.active {
      background: colors.$navy-color;
      color: colors.$white-color;
      font-weight: bold;
    }
  }
}
</style>
